<template>
  <kinesis-container
    class="column center relative full-size overflow-hidden flex background"
    :active="isParallax"
    :key="isParallax"
  >
    <kinesis-element class="full-size" type="depth" :strength="5">
      <HelloWorld />
    </kinesis-element>
    <div class="absolute right top first">
      <a :href="links.discord" target="_blank" rel="noopener noreferrer">
        <DiscorSvg class="icondiscord" />
      </a>
      <a :href="links.facebook" target="_blank" rel="noopener noreferrer">
        <FacebookSvg class="iconface" />
      </a>
      <a :href="links.twitter" target="_blank" rel="noopener noreferrer">
        <TwitterSvg class="icontwitter" />
      </a>
    </div>
    <div class="absolute left top first">
      <a :href="links.video" target="_blank" rel="noopener noreferrer">
        <PlaySvg class="iconplay" />
      </a>
    </div>
    <div class="absolute bottom left first r-social">
      <a :href="links.gamkat" target="_blank" rel="noopener noreferrer">
        <picture>
          <source
            srcset="./assets/img/icon_resize_gamkat.png"
            media="(min-width: 600px)"
          />
          <source
            srcset="./assets/img/icon_resize_gamkat.webp"
            type="image/webp"
          />
          <img
            alt="gamkat logo"
            src="./assets/img/icon_gamkat.svg"
            class="icongamkat"
          />
        </picture>
      </a>
    </div>
  </kinesis-container>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import DiscorSvg from "./components/DiscordSvg.vue";
import TwitterSvg from "./components/TwitterSvg.vue";
import PlaySvg from "./components/PlaySvg.vue";
import FacebookSvg from "./components/FacebookSvg.vue";
import { links } from "./constants";

export default {
  name: "App",
  components: {
    HelloWorld,
    DiscorSvg,
    TwitterSvg,
    PlaySvg,
    FacebookSvg,
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      txt: "",
      links: links,
      active: true,
    };
  },

  computed: {
    isParallax: function () {
      return this.windowHeight > 450;
    },
  },

  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/index";

body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background {
  background: rgb(75, 214, 254);
  background: linear-gradient(
    180deg,
    rgba(75, 214, 254, 1) 30%,
    rgba(113, 247, 255, 1) 100%
  );
}

.iconmedia {
  height: 45px;
}

.iconmonstro {
  height: 80px;
  padding-left: 20px;
  padding-bottom: 10px;
}

.icongamkat {
  height: 45px;
  padding-left: 25px;
  padding-bottom: 10px;
  transform: translateY(-20%);
}

.iconplay {
  height: 45px;
  padding-left: 30px;
  padding-top: 20px;
}

.iconface {
  height: 36px;
  padding-right: 25px;
  padding-top: 20px;
}

.icondiscord {
  height: 36px;
  padding-right: 30px;
}

.icontwitter {
  height: 34px;
  padding-right: 30px;
}

@media screen and (max-width: 1024px) {
  .iconmonstro {
    height: 100px;
    padding-left: 322px;
  }

  .icongamkat {
    height: 45px;
    padding-bottom: 20px;
  }

  .iconplay {
    height: 45px;
  }

  .iconface {
    height: 36px;
    padding-right: 30px;
  }

  .icondiscord {
    height: 35px;
    margin-top: 2vh;
    padding-right: 35px;
  }

  .icontwitter {
    height: 35px;
  }
}

@media (min-width: 1000px) {
  body {
    font-size: 4vw; // 1rem => 1px
  }
}

@media screen and (max-width: 780px) {
  .iconmonstro {
    height: 100px;
    padding-left: 212px;
    padding-bottom: 45px;
  }

  .icongamkat {
    padding-bottom: 30px;
  }
}

@media (max-width: 900px) and (orientation: landscape) {
  .icongamkat {
    height: 35px;
    padding-bottom: 10px;
  }

  .iconplay {
    height: 40px;
  }

  .iconface {
    height: 31px;
  }

  .icondiscord {
    height: 31px;
    margin-top: 3vh;
  }

  .icontwitter {
    height: 30px;
  }
}

@media (max-width: 730px) and (orientation: landscape) {
  .icongamkat {
    height: 35px;
    padding-bottom: 10px;
  }

  .iconplay {
    height: 40px;
  }

  .iconface {
    height: 31px;
  }

  .icondiscord {
    height: 31px;
    margin-top: 3vh;
  }

  .icontwitter {
    height: 30px;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 2vw; // 1rem => 1px
  }

  .r-social {
    margin: auto;
    left: auto !important;
    margin-bottom: 10px;
  }

  .iconmonstro {
    height: 75px;
    padding-left: 0;
  }

  .icongamkat {
    height: 35px;
    padding-bottom: 20px;
    padding-right: 30px;
  }

  .iconplay {
    height: 40px;
  }

  .iconface {
    height: 31px;
  }

  .icondiscord {
    height: 31px;
    margin-top: 3vh;
  }

  .icontwitter {
    height: 30px;
  }

@media screen and (max-width: 420px) {
    .iconmonstro {
      height: 75px;
      padding-left: 0;
      padding-bottom: 25px;
    }

    .icongamkat {
      height: 35px;
      padding-bottom: 25px;
      padding-right: 30px;
    }
  }
}

@media screen and (max-width: 320px) {
  .icongamkat {
    height: 30px;
    padding-bottom: 20px;
    padding-right: 45px;
  }

  .iconplay {
    height: 35px;
  }

  .iconface {
    height: 28px;
    padding-right: 25px;
  }

  .icondiscord {
    height: 28px;
    margin-top: 5vh;
    padding-right: 25px;
  }

  .icontwitter {
    height: 28px;
    padding-right: 20px;
  }
}
</style>
